import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ReturnToolListSectionStyled = styled.div`
  height: calc(100vh - 106px);
  box-shadow: 2px 0 4px 0 rgba(0, 0, 0, 0.16);

  padding-bottom: ${({ theme }) => theme.spacings['800']};
  width: inherit;
`;

export const SearchAreaStyled = styled(Box)`
  ${({ theme }) => css`
    border-color: ${theme.colors.blue[400]};
    padding: ${theme.spacings[450]} ${theme.spacings[500]};
  `}
  width:100%;
  svg {
    margin-right: ${({ theme }) => theme.spacings['450']};
  }
  input,
  Button {
    height: 44px;
  }
`;
